// extracted by mini-css-extract-plugin
export default {"searchForm":"bm_j8"};